import PathForMixin from '@/mixins/PathFor'
import WordingMixin from '@/mixins/Wording'
import SizesMixin from '@/mixins/Sizes'

import AppPicture from '@/components/app-picture/'
import AppAnimatedText from '@/components/app-animated-text/'
import AppPushButton from '@/components/app-push-button/'

export default
{
    name: 'app-page-home',

    mixins:
    [
        PathForMixin,
        WordingMixin,
        SizesMixin
    ],

    components:
    {
        AppPicture,
        AppAnimatedText,
        AppPushButton
    },

    data()
    {
        return {
            isLogoVisible: false,
            isTitleVisible: false,
            isButtonVisible: false,
            isButtonActive: false,
            isDescriptionVisible: false
        }
    },

    computed:
    {
        titleFormated: function()
        {
            let words = this.wording.home.title.split(' ')
            words = words.map((_item) => _item + ' ')

            return words
        }
    },

    mounted()
    {
        window.setTimeout(() =>
        {
            this.isTitleVisible = true
        }, 2000)

        window.setTimeout(() =>
        {
            this.isButtonVisible = true
        }, 120)

        window.setTimeout(() =>
        {
            this.isButtonActive = true
        }, 3000)

        window.setTimeout(() =>
        {
            this.isLogoVisible = true
        }, 3900)

        window.setTimeout(() =>
        {
            this.isDescriptionVisible = true
        }, 3900)
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-home/script.js